module.exports = __webpack_public_path__ + "/bundle/asset/exam-4-f83c38942bb76b48fee8375795567938.png";